import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import App from './App';
import * as serviceWorker from './serviceWorker';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 1.0,
    enableLogs: true,
    beforeSend(event) {
      if (event.request?.data?.password) {
        event.request.data.password = "[Filtered]";
      }
      return event;
    }
  });
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
